import { ViewType } from '@baserow/modules/database/viewTypes'

import KeyOfLifeCalendarView from '@keyoflife-views/components/KeyOfLifeCalendarView'
import KeyOfLifeKanbanView from '@keyoflife-views/components/KeyOfLifeKanbanView'
import KeyOfLifeTimelineView from '@keyoflife-views/components/KeyOfLifeTimelineView'
import KeyOfLifeMapView from '@keyoflife-views/components/KeyOfLifeMapView'

export class KeyOfLifeCalendarViewType extends ViewType {
  static getType() {
    return 'keyoflife_calendar'
  }

  getIconClass() {
    return 'iconoir-calendar'
  }

  getColorClass() {
    return 'color-success'
  }

  getName() {
    const { $i18n: i18n } = this.app
    return i18n.t('keyoflifeViews.calendarViewTypeName')
  }

  canSort() {
    return false
  }

  getComponent() {
    return KeyOfLifeCalendarView
  }
}

export class KeyOfLifeKanbanViewType extends ViewType {
  static getType() {
    return 'keyoflife_kanban'
  }

  getIconClass() {
    return 'iconoir-view-columns-3'
  }

  getColorClass() {
    return 'color-success'
  }

  getName() {
    const { $i18n: i18n } = this.app
    return i18n.t('keyoflifeViews.kanbanViewTypeName')
  }

  canSort() {
    return false
  }

  canFilter() {
    return true
  }

  getComponent() {
    return KeyOfLifeKanbanView
  }
}

export class KeyOfLifeTimelineViewType extends ViewType {
  static getType() {
    return 'keyoflife_timeline'
  }

  getIconClass() {
    return 'iconoir-timeline'
  }

  getColorClass() {
    return 'color-success'
  }

  getName() {
    const { $i18n: i18n } = this.app
    return i18n.t('keyoflifeViews.timelineViewTypeName')
  }

  canSort() {
    return false
  }

  getComponent() {
    return KeyOfLifeTimelineView
  }
}


export class KeyOfLifeMapViewType extends ViewType {
  static getType() {
    return 'keyoflife_map'
  }

  getIconClass() {
    return 'iconoir-map-pin'
  }

  getColorClass() {
    return 'color-success'
  }

  getName() {
    const { $i18n: i18n } = this.app
    return i18n.t('keyoflifeViews.mapViewTypeName')
  }

  canSort() {
    return false
  }

  getComponent() {
    return KeyOfLifeMapView
  }
}
